// extracted by mini-css-extract-plugin
export default {"wrapper":"PostSpaces_wrapper__bFZYP","otherSpaces":"PostSpaces_otherSpaces__4--ju","button":"PostSpaces_button__U0XiD"};